import React from 'react';
import { CheckCircleIcon, XCircleIcon, ClockIcon } from 'lucide-react';
import { TestimonialCard } from './TestimonialCard';
import { ProductFeature } from './ProductFeature';
import { CallToAction } from './CallToAction';
export function Advertorial() {
  return <article className="px-4 py-6 sm:px-6 md:px-8" data-id="element-9">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4" data-id="element-10">
        <span className="text-red-600" data-id="element-11">Stanford-Forscher schockiert:</span>
        <br data-id="element-12" />
        <span className="text-xl sm:text-2xl block mt-2" data-id="element-13">
          93% aller Rauchstopp-Versuche scheitern NICHT an mangelnder
          Willenskraft
        </span>
        <span className="text-xl sm:text-2xl block mt-2" data-id="element-14">
          - sondern an diesem{' '}
          <span className="bg-yellow-100 px-1" data-id="element-15">'Ritual-Vakuum'</span> in deinem
          Gehirn
        </span>
      </h1>
      <div className="mb-4 flex justify-center" data-id="element-16">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/smzEFxdfqtH1t717vLy5Zo/woman-4617256_1920.jpg" alt="Frau mit nachdenklichem Ausdruck - symbolisiert das Ritual-Vakuum" className="max-w-full rounded-lg shadow-md" data-id="element-17" />
      </div>
      <p className="text-gray-600 mb-6" data-id="element-18">
        Hier ist, was jeder Raucher über die wahre Ursache gescheiterter
        Aufhörversuche wissen muss.
      </p>
      <div className="mb-8" data-id="element-19">
        <p className="mb-4" data-id="element-20">
          Wenn du schon einmal versucht hast, mit dem Rauchen aufzuhören, kennst
          du dieses Gefühl nur zu gut.
        </p>
        <p className="mb-4" data-id="element-21">
          Vielleicht warst du drei Monate clean. Vielleicht sogar sechs. Du
          dachtest, du hättest es endlich geschafft. Dann kam dieser eine Moment
          - ein Glas Wein mit Freunden, ein stressiger Tag im Büro, oder einfach
          nur die Gewohnheit nach dem Essen - und plötzlich hattest du wieder
          eine Zigarette in der Hand.
        </p>
        <p className="mb-4 italic" data-id="element-22">
          "3 Monate Qualen umsonst, wie dämlich von mir", denkst du dir. "Werde
          ich nun mein Leben lang mit dem bewussten Nein-Sagen leben müssen?"
        </p>
        <p className="mb-4 font-medium" data-id="element-23">
          Aber was wäre, wenn ich dir sage, dass du NICHT schwach bist? Was
          wäre, wenn das Problem gar nicht an mangelnder Willenskraft liegt?
        </p>
      </div>
      <section className="mb-8" data-id="element-24">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-25">
          Die schockierende Entdeckung aus Stanford
        </h2>
        <p className="mb-4" data-id="element-26">
          Forscher der Stanford University haben in einer bahnbrechenden Studie
          mit über 3.000 Rauchern etwas Faszinierendes entdeckt: Das Rauchen
          besteht aus drei separaten neuralen Schleifen in deinem Gehirn:
        </p>
        <ul className="mb-6 space-y-2" data-id="element-27">
          <li className="flex items-start" data-id="element-28">
            <span className="mr-2 text-blue-500 font-bold" data-id="element-29">1.</span>
            <span data-id="element-30">
              <strong data-id="element-31">Chemische Abhängigkeit</strong> - Das Verlangen nach
              Nikotin
            </span>
          </li>
          <li className="flex items-start" data-id="element-32">
            <span className="mr-2 text-blue-500 font-bold" data-id="element-33">2.</span>
            <span data-id="element-34">
              <strong data-id="element-35">Motorische Gewohnheit</strong> - Die
              Hand-zum-Mund-Bewegung, jahrelang konditioniert
            </span>
          </li>
          <li className="flex items-start" data-id="element-36">
            <span className="mr-2 text-blue-500 font-bold" data-id="element-37">3.</span>
            <span data-id="element-38">
              <strong data-id="element-39">Olfaktorische Konditionierung</strong> - Dein Gehirn
              verbindet bestimmte Gerüche mit Entspannung
            </span>
          </li>
        </ul>
        <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-6" data-id="element-40">
          <p className="font-medium" data-id="element-41">
            Das Problem: Herkömmliche Methoden fokussieren sich nur auf eine
            oder maximal zwei dieser Schleifen. Die dritte Schleife bleibt
            unerfüllt - das erschafft das "Ritual-Vakuum".
          </p>
        </div>
        <p className="mb-4" data-id="element-42">
          Dieses Vakuum erzeugt konstanten neuralen Stress. Dein Gehirn sendet
          immer wieder Signale: "Die gewohnte Bewegung fehlt. Der vertraute
          Geschmack ist nicht da. Die entspannende Routine ist unterbrochen."
          Das ist das gefürchtete unstillbare Verlangen - nicht nur nach
          Nikotin, sondern nach dem vollständigen Ritual.
        </p>
      </section>
      <section className="mb-8" data-id="element-43">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-44">
          Warum alle bisherigen Methoden versagen
        </h2>
        <div className="space-y-4 mb-6" data-id="element-45">
          <div className="flex items-start" data-id="element-46">
            <div className="mr-3 mt-1 text-red-500" data-id="element-47">
              <XCircleIcon size={20} data-id="element-48" />
            </div>
            <div data-id="element-49">
              <h3 className="font-medium" data-id="element-50">
                Kalter Entzug (Willenskraft allein)
              </h3>
              <p className="text-gray-600" data-id="element-51">
                Die ersten 72 Stunden sind die Hölle. 95% Rückfallquote. Das
                Problem: Extreme Entzugserscheinungen, keine Unterstützung für
                deine jahrelang konditionierten Gewohnheiten, massive psychische
                Belastung.
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-52">
            <div className="mr-3 mt-1 text-red-500" data-id="element-53">
              <XCircleIcon size={20} data-id="element-54" />
            </div>
            <div data-id="element-55">
              <h3 className="font-medium" data-id="element-56">
                Nikotinersatztherapie (Pflaster, Kaugummi)
              </h3>
              <p className="text-gray-600" data-id="element-57">
                Lindern zwar körperliche Symptome, aber viele bleiben monatelang
                abhängig. Der widerliche Geschmack von Kaugummis, Hautreizungen
                durch Pflaster - und sie ersetzen nicht das Ritual des Rauchens.
                Du bleibst weiterhin nikotinabhängig.
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-58">
            <div className="mr-3 mt-1 text-red-500" data-id="element-59">
              <XCircleIcon size={20} data-id="element-60" />
            </div>
            <div data-id="element-61">
              <h3 className="font-medium" data-id="element-62">E-Zigaretten und Vapes</h3>
              <p className="text-gray-600" data-id="element-63">
                "Das Nikotin bleibt und die 'Rauch'-Gewohnheit auch." Ständig
                Akkus laden, Liquids nachfüllen. Du bist weiterhin abhängig von
                einer Substanz, die Langzeitfolgen sind unbekannt, und das
                soziale Stigma bleibt.
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-64">
            <div className="mr-3 mt-1 text-red-500" data-id="element-65">
              <XCircleIcon size={20} data-id="element-66" />
            </div>
            <div data-id="element-67">
              <h3 className="font-medium" data-id="element-68">
                Verschreibungspflichtige Medikamente
              </h3>
              <p className="text-gray-600" data-id="element-69">
                Champix, Zyban - wirken bei manchen, aber die Nebenwirkungen
                sind erschreckend. Angst vor Depressionen und Albträumen. Sehr
                teuer und verschreibungspflichtig.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mb-6" data-id="element-70">
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-71">
            Was wäre, wenn es endlich eine echte Alternative gäbe?
          </h3>
          <p className="mb-2" data-id="element-72">
            Stell dir vor, es gäbe eine Lösung, die alle drei neuralen Schleifen
            gleichzeitig bedient...
          </p>
          <p className="mb-2" data-id="element-73">
            Eine Lösung, die dir erlaubt, dein gewohntes Ritual beizubehalten -
            aber ohne die 7.000 giftigen Chemikalien...
          </p>
          <p className="mb-2" data-id="element-74">
            Eine Lösung, die in Deutschland entwickelt wurde, von
            Wissenschaftlern, die selbst jahrelang geraucht haben...
          </p>
          <p className="mb-4" data-id="element-75">
            Eine Lösung, die bereits Tausenden geholfen hat, endlich frei zu
            werden...
          </p>
          <p className="font-bold" data-id="element-76">
            Was wäre, wenn ich dir sage, dass diese Lösung existiert?
          </p>
        </div>
      </section>
      <section className="mb-8" data-id="element-77">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-78">
          Die bahnbrechende deutsche Innovation
        </h2>
        <p className="mb-4" data-id="element-79">
          Ein junges deutsches Startup hat nach jahrelanger Forschung etwas
          entwickelt, was die gesamte Rauchentwöhnung revolutioniert.
        </p>
        <p className="mb-4" data-id="element-80">
          Die Gründer - alle Ex-Raucher mit dutzenden gescheiterten Versuchen -
          erkannten das fundamentale Problem: Bisherige Lösungen bekämpfen nur
          die Sucht, aber ignorieren die Gewohnheit.
        </p>
        <p className="mb-4" data-id="element-81">
          Sie fragten sich: "Was wäre, wenn wir das Ritual beibehalten, aber
          gesund machen könnten?"
        </p>
        <p className="mb-4" data-id="element-82">
          Nach drei Jahren Entwicklung und Tests mit über 2.000 Probanden haben
          sie es geschafft:
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-center" data-id="element-83">
          <p className="font-medium mb-2" data-id="element-84">
            Den weltweit ersten aromatisierten rauchfreien Inhalator, der alle
            drei neuralen Schleifen perfekt nachahmt.
          </p>
          <h3 className="text-2xl font-bold text-blue-600" data-id="element-85">NUERA</h3>
        </div>
        <div className="flex justify-center mb-6" data-id="element-86">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Rc6S8MXXzX3mgG5rqrydm/airflavourdevice1-ezgif.com-video-to-gif-converter.gif" alt="NUERA Rauchfreier Inhalator in Bewegung" className="rounded-lg shadow-lg max-w-xs" data-id="element-87" />
        </div>
        <p className="mb-6" data-id="element-88">
          NUERA ist kein gewöhnlicher Ersatz. Es ist eine komplette
          Ritual-Simulation.
        </p>
        <h3 className="font-bold mb-3" data-id="element-89">
          Wie die "3-Schleifen-Methode" funktioniert:
        </h3>
        <div className="space-y-4 mb-6" data-id="element-90">
          <div className="flex items-start" data-id="element-91">
            <div className="mr-3 mt-1 text-green-500" data-id="element-92">
              <CheckCircleIcon size={20} data-id="element-93" />
            </div>
            <div data-id="element-94">
              <p data-id="element-95">
                <strong data-id="element-96">Für die motorische Schleife:</strong> Authentischer
                Zugwiderstand - deine Hände und dein Mund haben das exakt
                gleiche Gefühl wie beim Rauchen.
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-97">
            <div className="mr-3 mt-1 text-green-500" data-id="element-98">
              <CheckCircleIcon size={20} data-id="element-99" />
            </div>
            <div data-id="element-100">
              <p data-id="element-101">
                <strong data-id="element-102">Für die olfaktorische Schleife:</strong> Hochwertige
                natürliche ätherische Öle ersetzen die toxischen Chemikalien.
                Verfügbar in sieben verschiedenen Geschmacksrichtungen: Frische
                Minze, Orange, Vanille, Kaffee, Zitrone, Erdbeere und Blaubeere.
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-103">
            <div className="mr-3 mt-1 text-green-500" data-id="element-104">
              <CheckCircleIcon size={20} data-id="element-105" />
            </div>
            <div data-id="element-106">
              <p data-id="element-107">
                <strong data-id="element-108">Für die neurologische Komponente:</strong> Bewusste
                Atemregulierung aktiviert dein parasympathisches Nervensystem -
                dein natürliches Entspannungssystem.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-6" data-id="element-109">
          <p className="font-medium" data-id="element-110">
            Das Ergebnis: Das Ritual-Vakuum verschwindet. Dein Gehirn erhält
            alle neuralen Signale, die es erwartet - genau wie beim Rauchen, nur
            ohne die Gifte.
          </p>
        </div>
      </section>
      <section className="mb-8" data-id="element-111">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-112">
          Warum Markus nach 20 Jahren endlich frei ist
        </h2>
        <TestimonialCard name="Markus, 43" title="Vertriebsleiter aus München" image="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" story={`
            Markus rauchte seit seinem 16. Lebensjahr. Sieben gescheiterte Aufhörversuche lagen hinter ihm.
            "Nach der letzten gescheiterten Entwöhnung mit Pflastern dachte ich wirklich, ich bin zu schwach. Meine Frau war frustriert, meine Kinder fragten, warum Papa immer noch stinkt."
            Dann entdeckte Markus NUERA.
          `} timeline={[{
        period: 'Nach einer Woche',
        quote: 'Ich konnte es kaum glauben - das Verlangen war da, aber nicht diese verzweifelte Panik wie sonst. Der Stick gab mir das Gefühl des Rauchens, aber ohne die Schuldgefühle.'
      }, {
        period: 'Nach einem Monat',
        quote: 'Komplett rauchfrei. Keine Gewichtszunahme, weil ich den Stick statt Snacks verwende. Meine Kondition wird täglich besser. Beim Treppensteigen bin ich nicht mehr außer Atem.'
      }, {
        period: 'Nach drei Monaten',
        quote: 'Meine Familie ist so stolz auf mich. Ich rieche nicht mehr nach kaltem Rauch. Ich kann wieder richtig schmecken und riechen. Und das Beste: Ich spare über 200 Euro im Monat.'
      }, {
        period: 'Nach einem Jahr',
        quote: 'Das Leben ohne Zigarette ist nicht nur genau so schön, sondern 100-mal schöner als mit Zigarette. NUERA hat mir mein Leben zurückgegeben.'
      }]} data-id="element-113" />
      </section>
      <section className="mb-8" data-id="element-114">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-115">
          Die Wissenschaft dahinter
        </h2>
        <p className="mb-4" data-id="element-116">
          NUERA enthält ausschließlich natürliche ätherische Öle - 100%
          natürlich, ohne synthetische Chemikalien, ohne Zusatzstoffe oder
          Konservierungsmittel.
        </p>
        <p className="mb-6" data-id="element-117">
          Die Aromatherapie-Wirkung ist wissenschaftlich belegt: Bestimmte Düfte
          können das limbische System beeinflussen und natürliche
          Entspannungsreaktionen auslösen - genau das, was dein Gehirn beim
          Rauchen suchte.
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-118">
          <h3 className="font-bold mb-3" data-id="element-119">
            Mehr als 10.000 Deutsche haben es bereits geschafft
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-4" data-id="element-120">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Ms6AgSa5Hpuy3fywMTitQ/testimonial.png" alt="Zufriedene NUERA Nutzer mit ihren rauchfreien Inhalatoren" className="w-full max-w-md rounded-lg" data-id="element-121" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-122">
            <div className="bg-white p-3 rounded shadow-sm" data-id="element-123">
              <p className="italic text-sm" data-id="element-124">
                "Nach 18 Jahren Rauchen endlich frei - ohne Qualen, ohne
                Gewichtszunahme."
              </p>
              <p className="text-sm font-medium mt-2" data-id="element-125">- Julia, 38, Lehrerin</p>
            </div>
            <div className="bg-white p-3 rounded shadow-sm" data-id="element-126">
              <p className="italic text-sm" data-id="element-127">
                "Meine Familie ist so stolz auf mich. Keine
                Entzugserscheinungen, funktioniert auch in stressigen Momenten."
              </p>
              <p className="text-sm font-medium mt-2" data-id="element-128">
                - Thomas, 45, Ingenieur
              </p>
            </div>
            <div className="bg-white p-3 rounded shadow-sm" data-id="element-129">
              <p className="italic text-sm" data-id="element-130">
                "Das Ritual bleibt - nur gesund. Spare jetzt 180 Euro im Monat."
              </p>
              <p className="text-sm font-medium mt-2" data-id="element-131">
                - Sandra, 52, Bürokauffrau
              </p>
            </div>
            <div className="bg-white p-3 rounded shadow-sm" data-id="element-132">
              <p className="italic text-sm" data-id="element-133">
                "Auch meine rauchenden Kollegen sind neugierig geworden. Drei
                haben sich auch NUERA bestellt."
              </p>
              <p className="text-sm font-medium mt-2" data-id="element-134">
                - Michael, 41, Handwerker
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="mb-8" data-id="element-135">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-136">
          Was NUERA so besonders macht
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-137">
          <ProductFeature title="Authentisches Ritual" description="Der Zugwiderstand fühlt sich an wie eine echte Zigarette - deine Hand-zum-Mund-Gewohnheit bleibt erhalten." icon="Repeat" data-id="element-138" />
          <ProductFeature title="Vielseitig einsetzbar" description="Diskret nutzbar - auch in vielen Situationen, wo Rauchen tabu ist. Kein Dampf, kein Geruch, überall verwendbar." icon="Check" data-id="element-139" />
          <ProductFeature title="Langlebig und nachhaltig" description="Ein Aroma-Pod hält bis zu 4 Tage. Wiederverwendbar und kosteneffizient." icon="Leaf" data-id="element-140" />
          <ProductFeature title="Deutsche Qualität" description="Entwickelt in Deutschland nach höchsten Qualitätsstandards." icon="Award" data-id="element-141" />
          <ProductFeature title="Keine Abhängigkeit" description="100% nikotinfrei. Du tauschst nicht eine Sucht gegen eine andere." icon="ShieldCheck" data-id="element-142" />
        </div>
      </section>
      <section className="mb-8" data-id="element-143">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-144">
          Häufige Zweifel - ehrlich beantwortet
        </h2>
        <div className="space-y-4 mb-6" data-id="element-145">
          <div className="border-b border-gray-200 pb-3" data-id="element-146">
            <h3 className="font-medium mb-2" data-id="element-147">
              "Das ist nur ein teurer Strohhalm"
            </h3>
            <p className="text-gray-600" data-id="element-148">
              NUERA verfügt über eine patentierte Zugwiderstand-Technologie, die
              Jahre der Entwicklung kostete. Ein Jahr Zigaretten kostet
              durchschnittlich 2.500 Euro - NUERA ist eine einmalige Investition
              für deine Gesundheit.
            </p>
          </div>
          <div className="border-b border-gray-200 pb-3" data-id="element-149">
            <h3 className="font-medium mb-2" data-id="element-150">
              "Ich habe schon alles versucht"
            </h3>
            <p className="text-gray-600" data-id="element-151">
              Jeder deiner bisherigen Versuche hat dich näher zum Erfolg
              gebracht. NUERA ist anders, weil es nicht gegen deine Gewohnheiten
              arbeitet, sondern sie in eine gesunde Richtung lenkt. Du musst
              nicht verzichten - du ersetzt.
            </p>
          </div>
          <div className="border-b border-gray-200 pb-3" data-id="element-152">
            <h3 className="font-medium mb-2" data-id="element-153">
              "Ohne Nikotin bekomme ich schlimme Entzugserscheinungen"
            </h3>
            <p className="text-gray-600" data-id="element-154">
              Die Aromatherapie kann das Verlangen natürlich lindern. Viele
              Nutzer berichten von deutlich milderen Symptomen durch die
              beruhigenden ätherischen Öle und die Beibehaltung des Rituals.
            </p>
          </div>
          <div className="border-b border-gray-200 pb-3" data-id="element-155">
            <h3 className="font-medium mb-2" data-id="element-156">"Was ist mit Gewichtszunahme?"</h3>
            <p className="text-gray-600" data-id="element-157">
              NUERA hat null Kalorien und bietet orale Beschäftigung. Es ersetzt
              das Bedürfnis zu snacken, und die natürlichen Geschmäcker
              befriedigen süße oder würzige Gelüste.
            </p>
          </div>
        </div>
      </section>
      <section className="mb-8" data-id="element-158">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-159">
          Deine Transformation in den nächsten Wochen
        </h2>
        <div className="space-y-4 mb-6" data-id="element-160">
          <div className="flex" data-id="element-161">
            <div className="mr-4 flex-shrink-0" data-id="element-162">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-163">
                <ClockIcon size={24} className="text-blue-500" data-id="element-164" />
              </div>
            </div>
            <div data-id="element-165">
              <h3 className="font-medium" data-id="element-166">Nach 1 Woche</h3>
              <p className="text-gray-600" data-id="element-167">
                Deutlich weniger Rauchverlangen, besserer Schlaf, erste
                Verbesserung des Geschmacks- und Geruchssinns.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-168">
            <div className="mr-4 flex-shrink-0" data-id="element-169">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-170">
                <ClockIcon size={24} className="text-blue-500" data-id="element-171" />
              </div>
            </div>
            <div data-id="element-172">
              <h3 className="font-medium" data-id="element-173">Nach 1 Monat</h3>
              <p className="text-gray-600" data-id="element-174">
                Viele Nutzer sind komplett rauchfrei, gesparte Kosten bereits
                sichtbar, Stolz und Selbstvertrauen kehren zurück, bessere
                Kondition.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-175">
            <div className="mr-4 flex-shrink-0" data-id="element-176">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-177">
                <ClockIcon size={24} className="text-blue-500" data-id="element-178" />
              </div>
            </div>
            <div data-id="element-179">
              <h3 className="font-medium" data-id="element-180">Nach 3 Monaten</h3>
              <p className="text-gray-600" data-id="element-181">
                Vollständige neurale Umprogrammierung, besserer Geschmacks- und
                Geruchssinn, komplette soziale Akzeptanz ohne Raucherstigma.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-182">
            <div className="mr-4 flex-shrink-0" data-id="element-183">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-184">
                <ClockIcon size={24} className="text-blue-500" data-id="element-185" />
              </div>
            </div>
            <div data-id="element-186">
              <h3 className="font-medium" data-id="element-187">Nach 1 Jahr</h3>
              <p className="text-gray-600" data-id="element-188">
                Mehrere Tausend Euro gespart, drastisch reduziertes
                Gesundheitsrisiko, Vorbild für Familie und Freunde.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6" data-id="element-189">
          <h3 className="font-medium mb-2" data-id="element-190">30-Tage Geld-zurück-Garantie</h3>
          <p data-id="element-191">
            Teste NUERA konsequent für 30 Tage - täglich, wie empfohlen. Nur so
            kannst du die volle Wirkung erleben. Nicht zufrieden? Dann kannst du
            das Gerät zurückschicken und erhältst dein Geld zurück.
          </p>
        </div>
      </section>
      <section className="mb-8 text-center" data-id="element-192">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-193">
          Der Wendepunkt ist jetzt
        </h2>
        <p className="mb-4" data-id="element-194">
          Du stehst an einem Wendepunkt. Du kannst weiterhin das gleiche tun und
          die gleichen Ergebnisse erwarten - oder du kannst einen anderen Weg
          einschlagen.
        </p>
        <p className="mb-4" data-id="element-195">
          NUERA ist nicht nur ein Produkt. Es ist ein Werkzeug für deine
          Befreiung. Eine Brücke zwischen dem Leben, das du kennst, und dem
          Leben, das du verdienst.
        </p>
        <p className="mb-6" data-id="element-196">
          Du musst nicht mehr zwischen deiner Gesundheit und deinen Gewohnheiten
          wählen. Du musst nicht mehr kämpfen, verzichten oder dich schwach
          fühlen.
        </p>
        <p className="font-bold mb-6" data-id="element-197">
          Mit NUERA behältst du dein Ritual - machst es nur gesund.
        </p>
      </section>
      <CallToAction data-id="element-198" />
    </article>;
}